import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleCaretRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm2.157,8.621l-2.987,2.022c-.498,.337-1.17-.02-1.17-.621V6.978c0-.602,.672-.958,1.17-.621l2.987,2.022c.439,.297,.439,.945,0,1.242Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleCaretRightFill18.js.map